



















































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import UserIcon from 'mdi-vue/AccountSearch';
import AddIcon from 'mdi-vue/Plus';
import CheckIcon from 'mdi-vue/Check';
import CloseIcon from 'mdi-vue/Close';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import api from '@/libs/api';
import Modal from '@/components/Modal.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import TagInput from '@/components/TagInput.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import Tab from '@/components/Tab/Tab.vue';
import SummaryBox from '@/components/SummaryBox.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import numberFormat from '@/libs/numberFormat';
import FormInput from '@/components/FormInput.vue';
import {
  BankConfigCC, InvoiceProfileDetail, User,
} from '@/libs/api.interfaces';
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

interface LabelValue {
  label: string;
  value: number;
}

interface InstallmentList {
  [id: string]: {
    bank: BankConfigCC;
    tenors: BankConfigCC[];
  };
}

@Component({
  components: {
    Modal,
    FormInput,
    LayoutTitle,
    LayoutContent,
    TagInput,
    Table,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    Loader,
    Button,
    Tab,
    SummaryBox,
    SearchField,
    SearchRow,
    Select,
    TableBody,
    ScrollbarWrapper,
    UserIcon,
    AddIcon,
    CheckIcon,
    CloseIcon,
  },
  data() {
    return {
      listItems: [
        {
          productName: '',
          quantity: '',
          price: '',
          total: '',
        },
      ],
    };
  },
  methods: {
    numberFormat,
  },
  computed: mapState(['user']),
})
export default class EditProfileInvoice extends Vue {
  user!: {
    user: User;
  };

  merchantId = 0;
  profileName = '';
  mailSubject = '';

  sendTo = 'customer'
  officerEmails: SelectItem[] = [];

  viaEmail = true;
  viaSMS = false;
  viaWA = false;
  language = 'ind';
  // eslint-disable-next-line max-len
  mailBody = 'Dear %payname%\nSilahkan lanjutkan pembayaran dengan klik link %paylink% sebelum jatuh tempo %paydate%';
  // eslint-disable-next-line max-len
  smsBody = 'Dear %payname%\nSilahkan lanjutkan pembayaran dengan klik link %paylink% sebelum jth tempo %paydate%';
  // eslint-disable-next-line max-len
  waBody = 'Dear %payname%\nSilahkan lanjutkan pembayaran dengan klik link %paylink% sebelum jth tempo %paydate%';
  signature = '';
  amount = '';

  expirationDays = [...new Array(8)].map((e, i) => ({ label: `${i} Day${(i) > 1 ? 's' : ''}`, value: i }));
  expirationHours = [...new Array(25)].map((e, i) => ({ label: `${i} Hour${i > 1 ? 's' : ''}`, value: i }))
  expirationMinutes = [...new Array(60)].map((e, i) => ({ label: `${i} Minute${i > 1 ? 's' : ''}`, value: i }))

  expirationDay: null | LabelValue = null;
  expirationHour: null | LabelValue = null;
  expirationMinute: null | LabelValue = null;

  autoGenerateTransactionNumber = false;
  file: File | null = null;
  tosURL = '';
  currentLogo = '';

  loadingSubmit = false;
  loading = false;

  async submit() {
    try {
      this.loadingSubmit = true;

      const formData = new FormData();
      formData.append('user_group', '0');
      formData.append('merch_id', this.merchantId.toString());
      formData.append('name', this.profileName);
      formData.append('send_to', this.sendTo);

      if (this.sendTo === 'officer') {
        this.officerEmails.forEach((e) => {
          formData.append('email_officer[]', e.value);
        });
      }

      formData.append('subject', this.mailSubject);
      formData.append('mail_channel', this.viaEmail ? '1' : '0');
      formData.append('sms_channel', this.viaSMS ? '1' : '0');
      formData.append('wa_channel', this.viaWA ? '1' : '0');
      formData.append('language', this.language);
      formData.append('chck1', this.viaEmail ? '1' : '0');
      formData.append('chck2', this.viaSMS ? '1' : '0');

      if (this.viaEmail) {
        if (this.language === 'ind') {
          formData.append('wording', this.mailBody);
        } else {
          formData.append('wording_eng', this.mailBody);
        }
      }

      if (this.viaSMS) {
        if (this.language === 'ind') {
          formData.append('wording_sms', this.smsBody);
        } else {
          formData.append('wording_sms_eng', this.smsBody);
        }
      }

      if (this.viaWA) {
        if (this.language === 'ind') {
          formData.append('wording_wa', this.waBody);
        } else {
          formData.append('wording_wa_eng', this.waBody);
        }
      }

      formData.append('signature', this.signature);
      formData.append('transaction_fee', this.amount);
      formData.append('exp_days', this.expirationDay?.value.toString() || '0');
      formData.append('exp_hours', this.expirationHour?.value.toString() || '0');
      formData.append('exp_minutes', this.expirationMinute?.value.toString() || '0');
      formData.append('generate_trxno', this.autoGenerateTransactionNumber ? '1' : '0');
      formData.append('logo', this.currentLogo);
      formData.append('logo_url', this.currentLogo);

      if (this.file) {
        const image = new FormData();
        image.append('image', this.file as Blob);
        const imageUploadRes = await api.post('/upload', image);

        let path;
        if (this.$route.path.includes('merchant-lead')) {
          path = process.env.VUE_APP_SANDBOX_API_URL;
        } else {
          path = process.env.VUE_APP_API_URL;
        }

        // formData.append('logo', this.file);
        formData.set('logo', `${path}${imageUploadRes.data}`);
        formData.set('logo_url', `${path}${imageUploadRes.data}`);
      }

      formData.append('term_of_service', this.tosURL);

      let data;
      if (this.$route.name === 'EasyInvoiceProfileEdit') {
        formData.append('id', this.$route.params.id);
        data = await api.post('/easyinvoice/profiles_edit', formData);
      } else {
        data = await api.post('/easyinvoice/profiles_add', formData);
      }

      if (data.data.status === '00') {
        showToast(ToastType.SUCCESS, 'Success', data.data.message);
        this.$router.push({ name: 'EasyInvoiceProfiles' });
      } else {
        showToast(ToastType.FAILED, data.data.case, data.data.message.join(', '));
      }

      this.loadingSubmit = false;
    } catch (err) {
      console.error(err);
    }
  }

  async onFileInput(event: Event) {
    const target = event.target as HTMLInputElement;
    const { files } = target;

    if (files === null || files.length === 0) return;
    const [file] = files;
    this.file = file;
  }

  async getProfile() {
    try {
      this.loading = true;
      /* eslint-disable @typescript-eslint/camelcase */
      const { data } = await api.get<InvoiceProfileDetail>('/easyinvoice/profiles_detail', {
        params: {
          user_group: 0,
          merch_id: this.merchantId,
          id: this.$route.params.id,
        },
      });

      const profile = data.profile[0];
      this.profileName = profile.name;
      this.mailSubject = profile.subject_mail;
      this.sendTo = JSON.parse(profile.send_to).acc === 0 ? 'customer' : 'officer';
      this.viaEmail = profile.channel_mail === '1';
      this.viaSMS = profile.channel_sms === '1';
      this.viaWA = profile.channel_wa === '1';
      this.language = profile.wording_language;
      this.mailBody = profile.wording_language === 'ind' ? profile.wording_mail : profile.wording_mail_eng;
      this.smsBody = profile.wording_language === 'ind' ? profile.wording_sms : profile.wording_sms_eng;
      this.waBody = profile.wording_language === 'ind' ? profile.wording_wa : profile.wording_wa_eng;
      this.signature = profile.signature;
      this.amount = profile.transaction_fee;
      if (this.sendTo === 'officer') {
        // const officerEmail = JSON.parse(profile.send_to).email as string;
        // this.officerEmails = [{ key: officerEmail, value: officerEmail }];
        const officerEmail = JSON.parse(profile.send_to).email as string;
        if (typeof officerEmail === 'string') {
          const officerEmailsS = officerEmail.split(',');
          this.officerEmails = officerEmailsS.map((e) => ({ key: '', value: e }));
        } else {
          this.officerEmails = [];
        }
      }

      this.expirationDay = this.expirationDays[data.exp_day];
      this.expirationHour = this.expirationHours[data.exp_hour];
      this.expirationMinute = this.expirationMinutes[data.exp_minute];

      this.tosURL = profile.term_of_service;

      this.autoGenerateTransactionNumber = profile.generate_trxno === '1';
      this.currentLogo = profile.logo;

      this.loading = false;
    } catch (err) {
      console.error(err);
    }
  }

  @Watch('language')
  languageOnChange() {
    /* eslint-disable max-len */
    if (this.language === 'ind') {
      this.mailBody = 'Dear %payname%\nSilahkan lanjutkan pembayaran dengan klik link %paylink% sebelum jatuh tempo %paydate%';
      this.smsBody = 'Dear %payname%\nSilahkan lanjutkan pembayaran dengan klik link %paylink% sebelum jth tempo %paydate%';
      this.waBody = 'Dear %payname%\nSilahkan lanjutkan pembayaran dengan klik link %paylink% sebelum jth tempo %paydate%';
    } else {
      this.mailBody = 'Dear %payname%\nPlease continue the payment by clicking the link %paylink% before the due date %paydate%';
      this.smsBody = 'Dear %payname%\nPlease continue the payment by clicking the link %paylink% before the due date %paydate%';
      this.waBody = 'Dear %payname%\nPlease continue the payment by clicking the link %paylink% before the due date %paydate%';
    }
    /* eslint-enable max-len */
  }

  mounted() {
    this.merchantId = this.user.user.merchant_id;
    if (this.$route.name === 'EasyInvoiceProfileEdit') {
      this.getProfile();
    }
  }
}
